<template>
    <div id="contactForm">
        <form method="post" :action="formAction" novalidate>
            <div class="col-md-6 col-sm-6 col-xs-12">
                <div class="form-group" :class="{ 'has-error': $v.vorname.$error }">
                    <label for="vorname" style="display:none;">Vorname</label>
                    <input type="text" class="form-control" id="vorname" name="vorname" placeholder="Vorname*"
                           v-model.trim="$v.vorname.$model" @blur="$v.vorname.$touch()">
                    <span class="form-error text-danger" v-if="$v.vorname.$error"><small>Vorname wird benötigt</small></span>
                </div>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-12">
                <div class="form-group" :class="{ 'has-error': $v.nachname.$error }">
                    <label for="nachname" style="display:none;">Nachname</label>
                    <input type="text" class="form-control" id="nachname" name="nachname" placeholder="Nachname*"
                           v-model.trim="$v.nachname.$model" @blur="$v.nachname.$touch()">
                    <span class="form-error text-danger" v-if="$v.nachname.$error"><small>Nachname wird benötigt</small></span>
                </div>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-12">
                <div class="form-group" :class="{ 'has-error': $v.email.$error }">
                    <label for="email" style="display:none;">E-Mail Adresse</label>
                    <input type="email" class="form-control" id="email" name="email" placeholder="E-Mail Adresse*"
                           v-model.trim="$v.email.$model" @blur="$v.email.$touch()">
                    <div class="form-error text-danger" v-if="$v.email.$error">
                        <small>E-Mail wird benötigt</small>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-12">
                <div class="form-group">
                    <label for="telefon" style="display:none;">Telefonnummer</label>
                    <input type="number" class="form-control" id="telefon" name="telefon" placeholder="Telefonnummer">
                    <small class="form-text text-muted">Warum benötigen wir Ihre Telefonnummer <a
                            data-toggle="tooltip" data-placement="bottom"
                            title="Auf Basis Ihrer Anfrage erstellen wir Ihnen ein ganz individuelles und auf Sie zugeschnittenes Angebot für Ihre Traumreise. Ihre Telefonnummer ermöglicht uns eine schnellere und effektivere Klärung von Rückfragen. Zudem schätzen wir einen persönlichen Kontakt mit unseren Kunden sehr und möchten zu 100% Ihre Wünsche und Vorstellungen im Angebot berücksichtigen.
In keinem Fall werden wir Ihre Daten zu Werbezwecken an Dritte weitergeben. Falls Sie eine Angabe der Telefonnummer dennoch nicht wünschen, können Sie dieses Feld auch leer lassen und das Formular mit Ihrer E-Mail an uns absenden. Wir werden Sie dann auf diesem Wege schnellstmöglich kontaktieren.
"><i
                            class="fas fa-info-circle"></i></a></small>
                </div>
            </div>


            <div class="col-md-12 col-sm-12 col-xs-12">
                <div class="form-group">
                    <label for="nachricht" style="display:none;">Nachricht</label>
                    <textarea class="form-control" id="nachricht" name="nachricht" placeholder="Persönliche Nachricht"
                              rows="4"></textarea>

                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-xs-12">
                <div class="form-check">
                    <input type="checkbox" name="newsletter" class="form-check-input" id="exampleCheck13">
                    <label class="form-check-label" for="exampleCheck13">Wünschen Sie Reisetipps und Sonderangebote?
                        Setzen Sie hier einen Haken und erhalten regelmäßig und kostenlos unsere besten Reisetipps und
                        Sonderangebote zu unseren Destinationen. Ihre Daten werden selbstverständlich nicht an Dritte
                        weitergegeben und dienen nur zum Zwecke Sie über unsere Angebote zu informieren. Sie können sich
                        jederzeit von unserem Newsletter abmelden.
                    </label>
                </div>
                <div class="form-check" :class="{ 'has-error': $v.datenschutzKontakt.$error }">
                    <input type="checkbox" v-model.trim="$v.datenschutzKontakt.$model" name="datenschutzKontakt"
                           class="form-check-input" id="datenschutzKontakt">
                    <label class="form-check-label" for="datenschutzKontakt">*Ich bin damit einverstanden, dass meine
                        personenbezogenen Daten vom Reisebüro/Reiseveranstalter für Kundeninformationen gespeichert,
                        verarbeitet und genutzt werden. Mir ist bekannt, dass ich Auskunft über gespeicherte Daten
                        verlangen kann. Ich bin damit einverstanden, dass meine Kontaktinformationen an Partner im
                        Zielland weitergegeben werden, um mich in dringenden Fällen erreichen zu können. Ich akzeptiere
                        die <a href="/datenschutz">Datenschutzbestimmungen</a></label>

                </div>
                <button type="submit" class="btn btn-primary" :disabled="$v.$invalid">Absenden</button>
                <div v-if="$v.$invalid" class="text-danger form-incomplete">Bitte füllen Sie alle Pflichtfelder (*)
                    aus
                </div>

            </div>
        </form>
    </div>
</template>

<script>

    import {required, email, sameAs} from 'vuelidate/lib/validators'

    export default {
        name: 'App',
        components: {},
        data() {
            return {
                formAction: '',
                vorname: '',
                nachname: '',
                email: '',
                telefon: '',
                nachricht: '',
                newsletter: '',
                datenschutzKontakt: ''
            }
        },
        validations: {
            vorname: {
                required,
            },
            nachname: {
                required,
            },
            email: {
                required,
                email
            },
            datenschutzKontakt: {
                sameAs: sameAs(() => true)
            }
        },
        methods: {},
        mounted() {
            this.formAction = this.$parent.formAction;
        }
    }
</script>

<style scoped>
    .form-group {
        min-height: 2.75em;
    }

    form .form-error {
        position: absolute;
    }

    .form-incomplete {
        margin-top: .5em
    }

</style>
